'use client';

import { gridCol, gridRow } from '@mage-ui/styled-system/recipes';
import { useContext } from 'react';
import { StaticTextContext } from '@/components/context/StaticTextProvider';
import { GridCol } from '../../layouts/grids/GridCol';
import { GridRow } from '../../layouts/grids/GridRow';
import { ShopCard } from '../cards/shop-card/ShopCard';

export const DossierList = ({ dossiers, languages, cartLink }) => {
	const { st } = useContext(StaticTextContext);

	const getDossierLanguage = ({ language_id: languageId }) =>
		languageId
			? languages.find(
					(language) => language.fields.id_backend === `${languageId}`,
				)?.fields
			: {};

	return (
		<GridRow
			className={gridRow({
				gapM: 'gap200',
				gapL: 'gap300',
			})}
		>
			{dossiers?.map((item) => {
				const infoData = [
					{
						name: st('register.name'),
						value: item?.name,
					},
					{
						name: st('register.level'),
						value: item?.level,
					},
					{
						name: st('register.professor'),
						value: item?.professor,
					},
					{
						name: st('register.schedule'),
						value: item?.schedule,
					},
					{
						name: st('register.price'),
						value: item?.formatted_price,
						summary: true,
					},
				];

				const language = getDossierLanguage(item);

				return (
					<GridCol
						key={item?.id}
						className={gridCol({ colSpanM: '4', colSpanL: '4' })}
					>
						<ShopCard
							data={{
								id: item?.id,
								language: language?.name,
								name: item?.name,
								group_id: item?.group_id,
								price: item?.price,
								iso: language?.iso,
								enabled: item?.enabled,
								infoData,
								cartLink,
							}}
						/>
					</GridCol>
				);
			})}
		</GridRow>
	);
};
